import Logo from '../../assets/company_logo.svg';
import {Button} from '@mayo/mayo-ui-gakki';
import React from 'react';
import {useAuth} from './context/auth-context';

export function UnauthenticatedApp() {
  const {login} = useAuth();
  return (
    <div
      className={'w-full h-full flex items-center justify-center'}
      style={{
        background: 'linear-gradient(26deg, rgb(0, 5, 39), rgb(38, 171, 227))',
      }}
    >
      <div
        className={
          'h-[350px] bg-white w-[350px] flex flex-col items-center p-4'
        }
        style={{
          boxShadow: '0 10px 15px rgba(0,0,0,0.5)',
        }}
      >
        <img
          alt="apollo-xe logo"
          src={Logo}
          className={'w-[200px] mt-24 mb-24'}
        />
        <Button
          variant={'solid'}
          colorSchema={'primary'}
          onClick={login}
        >
          登入
        </Button>
      </div>
    </div>
  );
}

export default UnauthenticatedApp;
